import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['requestedArticles'] = {},
  action: Action,
): RootState['requestedArticles'] {
  switch (action.type) {
    case 'ADD_REQUESTED_ARTICLE': {
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    }
    case 'UPDATE_REQUESTED_ARTICLE': {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], ...action.payload },
      }
    }
    default:
      return state
  }
}
